module.exports = __webpack_public_path__ + "static/media/87.4a12ce9b.jpg";